import express from 'express';
import { parsePayload } from '~/app/middleware';
import { duplicate, getContentTypes } from '~/app/middleware/ContentTypes';

const duplicateRouter = express.Router();

duplicateRouter.post('{/:preview}', parsePayload, getContentTypes, duplicate);

export default duplicateRouter;
